import React, { Component, ErrorInfo } from "react";
import { IProps, IState } from './types';
import ErrorPage from "@routes/private/ErrorPage";

class ErrorBoundary extends Component<IProps, IState> {
  state = { error: null };

  static getDerivedStateFromError(error: Error): IState {
    return { error };
  }

  componentDidCatch(error: Error) {
    this.props.onError(error);
  }

  render() {
    if (this.state.error !== null) {
      return <ErrorPage />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;